export const PSU_FORM_NAME = "PRODUCT_SIGNUP_FORM";
